<template>
    <div class="container-fluid ps-md-0">
        <div class="row g-0">
            <div class="d-none d-md-flex col-md-4 col-lg-6 bg-image"></div>
            <div class="col-md-8 col-lg-6">
                <div class="login d-flex align-items-center py-5">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-9 col-lg-8 mx-auto">
                                <h2 class="login-heading mb-4"><b>ContactWeb Administrace</b></h2>
                                <form @submit.prevent="login">
                                    <div class="form-floating mb-3">
                                        <input type="text" class="form-control" id="floatingInput" placeholder="name@example.com" v-model="username" />
                                        <label for="floatingInput">Přihlašovací jméno</label>
                                    </div>
                                    <div class="form-floating mb-3">
                                        <input type="password" class="form-control" id="floatingPassword" placeholder="Password" v-model="password" />
                                        <label for="floatingPassword">Heslo</label>
                                    </div>
                                    <div class="d-grid">
                                        <button class="btn btn-lg btn-primary btn-login text-uppercase fw-bold mb-2" type="submit">Přihlásit se</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "LoginComponent",
    data() {
        return {
            username: "",
            password: "",
        };
    },
    methods: {
        async login() {
            const response = await axios.post("http://admin.contactweb.cz/api/account/login?username=" + this.username + "&password=" + this.password);

            localStorage.setItem("token", response.data.token);
            if (response.status == 200) {
                this.$router.push("/");
            }
        },
    },
};
</script>

<style>
.login {
    min-height: 100vh;
}

.bg-image {
    background-image: url("https://source.unsplash.com/WEQbe2jBg40/600x1200");
    background-size: cover;
    background-position: center;
}

.login-heading {
    font-weight: 300;
}

.btn-login {
    font-size: 0.9rem;
    letter-spacing: 0.05rem;
    padding: 0.75rem 1rem;
}
</style>
